import { createAction, createRequestTypes, FAILURE, REQUEST, SUCCESS } from '../../../utils/actionGenerator';

export const GET_UPLOAD_TYPES = createRequestTypes('GET_UPLOAD_TYPES');
export const UPLOAD_BULK_FILE = createRequestTypes('UPLOAD_BULK_FILE');
export const RESET_UPLOAD_STATUS = 'RESET_UPLOAD_STATUS';

export const uploadBulkFile = {
  request: (payload) => createAction(UPLOAD_BULK_FILE[REQUEST], { payload }),
  success: (response) => createAction(UPLOAD_BULK_FILE[SUCCESS], { response }),
  failure: (response) => createAction(UPLOAD_BULK_FILE[FAILURE], { response }),
};

export const getUploadTypes = {
  request: () => createAction(GET_UPLOAD_TYPES[REQUEST]),
  success: (response) => createAction(GET_UPLOAD_TYPES[SUCCESS], { response }),
  failure: (response) => createAction(GET_UPLOAD_TYPES[FAILURE], { response }),
};

export const resetUploadStatus = () => createAction(RESET_UPLOAD_STATUS);

